import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material.module';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CardsService, DigitalCard } from 'src/app/services/cards.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbComponent } from 'src/app/components/shared/breadcrumb/breadcrumb.component';

interface EventData {
  id: string;
  cardId: string;
  eventType: string;
  email?: string;
  phone?: string;
  name?: string;
  handlerId?: string;
  userId?: string;
  createdAt: any;
  updatedAt: any;
}

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule, ReactiveFormsModule, BreadcrumbComponent]
})
export class AnalyticsComponent implements OnInit {
  eventData: { [key: string]: EventData[] } = {};
  counts: { [key: string]: number } = {};
  selectedEventType: string = 'all';
  filteredEvents: EventData[] = [];
  eventTypes: string[] = [];
  loading = false;
  
  cards: DigitalCard[] = [];
  selectedCardControl = new FormControl('');

  displayedColumns: string[] = ['name', 'email', 'phone', 'eventType', 'createdAt'];

  constructor(
    private analyticsService: AnalyticsService,
    private cardsService: CardsService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      this.cards = await this.cardsService.getUserCards();
      
      if (this.cards.length > 0) {
        this.selectedCardControl.setValue(this.cards[0].id);
        await this.loadAnalytics(this.cards[0].id);
      }

      this.selectedCardControl.valueChanges.subscribe(async (cardId) => {
        if (cardId) {
          await this.loadAnalytics(cardId);
        }
      });
    } catch (error) {
      console.error('Error initializing analytics:', error);
    } finally {
      this.loading = false;
    }
  }

  private async loadAnalytics(cardId: string): Promise<void> {
    try {
      this.loading = true;
      const response = await this.analyticsService.getUserEvents(cardId);
      this.eventData = response.events;
      this.counts = response.counts;
      
      // Get event types excluding 'visited'
      this.eventTypes = Object.keys(this.eventData).filter(type => type !== 'visited');
      this.filterEvents('all');
    } catch (error) {
      console.error('Error loading analytics:', error);
    } finally {
      this.loading = false;
    }
  }

  filterEvents(eventType: string) {
    this.selectedEventType = eventType;
    
    if (eventType === 'all') {
      this.filteredEvents = Object.entries(this.eventData)
        .filter(([type]) => type !== 'visited')
        .flatMap(([_, events]) => events);
    } else {
      this.filteredEvents = this.eventData[eventType] || [];
    }
  }
}